import { useTranslations } from "@harea/component";

export const useRefuseDayOffForm = () => {
    const [SELECT_REASON, REFUSE_REASON, CONFIRM, INSUFFICIENT_BALANCE, NOT_ELIGIBLE, STAFFING_NEEDS, OVERLAPPING_REQUEST, OTHER] = useTranslations(i18n);

    const REFUSE_REASONS = [
        { label: INSUFFICIENT_BALANCE, value: "insufficient_balance" },
        { label: NOT_ELIGIBLE, value: "not_eligible" },
        { label: STAFFING_NEEDS, value: "staffing_needs" },
        { label: OVERLAPPING_REQUEST, value: "overlapping_request" },
        { label: OTHER, value: "other" },
    ];

    return {
        data: {
            title: "",
            forms: [
                {
                    type: 'select',
                    name: 'refuseReason',
                    label: SELECT_REASON,
                    options: REFUSE_REASONS,
                    placeholder: SELECT_REASON,
                },
                {
                    type: 'textarea',
                    name: 'customReason',
                    label: REFUSE_REASON,
                    placeholder: REFUSE_REASON,
                    rows: 4,
                    visible: (values: any) => values.refuseReason === 'other',
                },
            ],
            events: [
                {
                    name: "refuseReason",
                    type: "change" as const,
                    condition: [
                        { var_1: "${refuseReason}", op: "!=" as const, var_2: "other" },
                    ],
                    conditionIfRules: [
                        { name: "customReason", op: "hide" as const },
                    ],
                },
            ],
            next: {
                label: CONFIRM,
                endIcon: 'fas fa-check',
                className: 'btn-danger'
            },
        },
    };
};

const i18n = [
    "BSMRH.DayOff.Refuse.SelectReason",
    "std_reason",
    "std_confirm",
    "std_insufficient_balance",
    "std_not_eligible",
    "std_staffing_needs",
    "std_overlapping_request",
    "std_other"
];
